import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { actionUpdateUserData, actionUploadUserPicture } from '@lib/core/users/slices/user';
import { localeCommon } from '@lib/tools/locale/source/web/common';
import { TToastMessages } from '@lib/tools/toastMessage/types/interfaces';
import { ToastMessageTypes } from '@lib/tools/toastMessage/utils/consts';

export interface IToastMessageSlice {
  toastMessage: TToastMessages | null;
}

const initialState: IToastMessageSlice = {
  toastMessage: null,
};

const { ToastMessages } = localeCommon;

export const toastMessageSlice = createSlice({
  extraReducers: builder => {
    builder.addCase(actionUploadUserPicture.fulfilled, state => {
      state.toastMessage = {
        message: ToastMessages.profilePictureSuccess,
        type: ToastMessageTypes.success,
      };
    });
    builder.addCase(actionUploadUserPicture.rejected, state => {
      state.toastMessage = {
        message: ToastMessages.profilePictureFailed,
        type: ToastMessageTypes.error,
      };
    });
    builder.addCase(actionUpdateUserData.fulfilled, state => {
      state.toastMessage = {
        message: ToastMessages.userDataSuccess,
        type: ToastMessageTypes.success,
      };
    });
    builder.addCase(actionUpdateUserData.rejected, state => {
      state.toastMessage = {
        message: ToastMessages.userDataFailed,
        type: ToastMessageTypes.error,
      };
    });
  },
  initialState,
  name: 'toastMessage',
  reducers: {
    actionAddToastMessage: (state, action: PayloadAction<TToastMessages>) => {
      state.toastMessage = action.payload;
    },
    actionClearToastMessage: state => {
      state.toastMessage = null;
    },
  },
});

export const { actionClearToastMessage, actionAddToastMessage } = toastMessageSlice.actions;

export default toastMessageSlice.reducer;
